module.exports = __webpack_public_path__ + "static/media/vector-4965.13a8f10b.svg";